import * as React from 'react';
import { SwitchBase, SwitchBaseProps } from '../SwitchBase/SwitchBase';
import { TickIcon } from '../../icons/TickIcon';
import { ResponsiveStyleValue } from '../../theming';
import { FixMeLater } from '../../utils';
import { STATIC_STYLES, useDynamicStyles } from './Switch.styles';

export type SwitchSize = 's' | 'm';
export interface SwitchProps extends SwitchBaseProps {
    /**
     * The size variant of the component.
     */
    size?: ResponsiveStyleValue<SwitchSize>;

    /**
     * A reference passed to the `input` element.
     */
    inputRef?: React.Ref<HTMLInputElement>;
}

/**
 * A Switch is a stylised version of a checkbox. They are typically used to toggle the state of a single setting on or off.
 */
export const Switch: React.ForwardRefExoticComponent<SwitchProps & React.RefAttributes<HTMLElement>> = React.forwardRef(
    function Switch(props: SwitchProps, ref: React.ForwardedRef<FixMeLater>): React.JSX.Element {
        const { checked, size: sizeProp = 'm', inputRef, ...other } = props;

        const dynamicStyles = useDynamicStyles(sizeProp);

        return (
            <div ref={ref} style={dynamicStyles} css={STATIC_STYLES} data-switch-root={true}>
                <SwitchBase ref={inputRef} checked={checked} data-switch-input={true} {...other} />
                <div data-switch-track={true}>
                    <div data-switch-handle={true}>
                        <TickIcon data-switch-icon={true} />
                    </div>
                </div>
            </div>
        );
    }
);
